module.exports = __webpack_public_path__ + "/assets/img/icon_plentye91878f1.svg";